import { formatterForCurrency } from 'Pages/Home/Helper/Formatter';
import React, { useMemo } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';

import { IRelatedProductItemProps } from './RelatedProductItem.definitions';
import { emptyImage } from 'utils';

/** CSS import */
import Styles from './RelatedProductItem.module.scss';

const RelatedProductItem: React.FC<IRelatedProductItemProps> = ({
  name,
  price,
  image,
  category,
  brandSlug,
  slug,
}: IRelatedProductItemProps) => {
  const displayPrice = useMemo(() => {
    if (!price) {
      return '-';
    }

    return formatterForCurrency(price, 'IDR');
  }, [price]);

  const [currentImage, setCurrentImage] = React.useState(image);
  
  return (
    <Link to={`/${category}/${brandSlug}/${slug}`}>
      <div className={Styles['wrapper']}>
        <p className={Styles['name']}>{name || '-'}</p>
        <p className={Styles['price']}>{displayPrice}</p>
        <div className={Styles['img-box']}>
          <KickImage src={currentImage} onError={() => setCurrentImage(emptyImage(category))} alt={name} />
        </div>
      </div>
    </Link>
  );
};

export default RelatedProductItem;
